import './base';
import SmartPhoto from 'smartphoto';
import {
  LazyMap
} from './src/lazymap';
import {
  filterByLinks
} from './src/map/links';


new SmartPhoto('.js-smartphoto', {
  nav: false
});

const lazyMap = new LazyMap('.lazymap');
filterByLinks(lazyMap);
